<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import DataFieldForm from '@/components/data-fields/DataFieldForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        data_field_name: '',
        data_field_status: '',
        data_field_group: '',
        data_field_color: '',
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.data-fields.store')"
        :query-key="[QueryKey.DATA_FIELDS]"
        title="system.add_data_field"
        button-text="system.add_data_field"
    >
        <DataFieldForm :form="form" />
    </DialogForm>
</template>
